import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { usePAIOrdersState } from '../../../stores/PAIOrdersTableProvider'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getErrorMessageFromApiResponse } from "../../../utils/api/apiUtils"
import PAIOrdersTable from '../../PAIOrders/PAIOrdersTable'
import useStores from '../../../stores/useStore'
import ModalComponent2 from '../../Modals/ModalComponent2'
import { Observer } from 'mobx-react'
const StyledHeaderButtons = styled.div`

@media screen and (min-width:768px) {
    display:flex;
    justify-content: end;
}
@media (max-width: 767px)  {
    .customDropdown{
        margin-bottom:1rem;
    }
    button{
        width:100%;
        margin-bottom:1rem;
    }
}
`


const PAIOrdersApproval = () => {
  const { selectedCheckBoxes, setSelectedCheckBoxes, fetchOrders } = usePAIOrdersState()
  const [release, setRelease] = useState(false)
  const [reject, setReject] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const { uiStore } = useStores()

  const submit = async (type, message) => {
    setError('')
    const endpoint = prepareEndpoint(type)
    const params = prepareParams(message)
    try {
      setIsLoading(true)
      await apiClient.postJson(endpoint, params)
      setSelectedCheckBoxes([])
      fetchOrders()
      cancelActions()
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    } finally {
      setIsLoading(false)
    }
  }

  //array of ids to array of objects [id1,id2] => [{comment:"",id:id1},{comment:"", id:id2}]
  const prepareParams = (message) => {
    const result = selectedCheckBoxes.map(id => {
      var rObj = {}
      rObj.comment = message
      rObj.id = id
      return rObj
    })
    return result
  }

  const prepareEndpoint = (type) => {
    let endpoint = ''
    switch (type) {
      case 'release':
        endpoint = APIEndpoints.paiOrders().releases
        break;
      case 'reject':
        endpoint = APIEndpoints.paiOrders().rejections
        break;
      default:
      // code block
    }
    return endpoint
  }

  const cancelActions = () => {
    setRelease(false)
    setReject(false)
    setIsLoading(false)
    setError('')
  }

  return (<Observer>{() => (
    <>
      <StyledHeaderButtons>
        {uiStore.allowReleasePAIOrders ? <div>
          <Button
            className="mb-3 me-2"
            disabled={selectedCheckBoxes.length === 0 || isLoading}
            variant="success"
            onClick={() => setRelease(true)}
          >{t('release')}</Button>
          <Button
            className="mb-3"
            disabled={selectedCheckBoxes.length === 0 || isLoading}
            variant="danger"
            onClick={() => setReject(true)}
          >{t('reject')}</Button>
        </div>
          : null}
      </StyledHeaderButtons>
      <PAIOrdersTable />
      {reject && (<ModalComponent2
        ModalTitle={t('paiOrders:rejectApprovalTitle')}
        BodyPart1={t('paiOrders:rejectApprovalBody')}
        button1Function={(comment) => { submit('reject', comment) }}
        button1Text={t('reject')}
        button1Variant="danger"
        button1Loading={isLoading}
        bodyStyle="alert alert-danger"
        functionCancel={cancelActions}
        inputType="textarea"
        inputLabel={t('comment')}
        error={error}
      />)}
      {release && (<ModalComponent2
        ModalTitle={t('paiOrders:releaseApprovalTitle')}
        BodyPart1={t('paiOrders:releaseApprovalBody')}
        button1Function={() => { submit('release', '') }}
        button1Text={t('release')}
        button1Variant="success"
        button1Loading={isLoading}
        bodyStyle="alert alert-success"
        functionCancel={cancelActions}
        error={error}
      />)}
    </>
  )}</Observer>)
}

export default PAIOrdersApproval
